import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnDestroy
} from "@angular/core";
import { OptionTypesService } from "../../shared/services/option-types.service";
import { FeedbackService } from "../../shared/services/feedback.service";
import { QuestionsService } from "../questions.service";
import { Question } from "../../shared/models/question.model";
import { NgForm } from "@angular/forms";
import { IQuestion } from "../../shared/models/interfaces/question";
import { IOptionType } from "../../shared/models/interfaces/option-type";
import { CdkDragDrop, CdkDrag, CdkDropList, CdkDropListGroup, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { IOptionValue } from "../../shared/models/interfaces/option-value";
import { OptionValue } from "../../shared/models/option-value.model";
import { IOption } from "../../shared/models/interfaces/option";
import { Option } from "../../shared/models/option.model";
import { ControlHelpers } from "../../shared/helpers/control.helpers";
import { QuestionGroupQuestion } from "../../shared/models/question-group-question.model";
import { QuestionGroupsService } from "../../question-groups/question-groups.service";
import { IQuestionGroup } from "../../shared/models/interfaces/question.group";
import { OptionValueQuestionGroup } from "../../shared/models/option-value-question-group.model";
import * as _ from "lodash";
import { IOptionValueQuestionGroup } from "../../shared/models/interfaces/option-value-question-group";
import { IAssessmentMessage } from "../../shared/models/interfaces/assessment-message";
import { ControlType } from "../../shared/enums/control-type.enum";
import CheckBoxList = ControlType.CheckBoxList;
import RadioButtonList = ControlType.RadioButtonList;
import { IPartnerType } from "../../shared/models/interfaces/partner-type";
import { PartnerService } from "../partner.service";
import { IQuestionType } from "../../shared/models/interfaces/question-type";
import { takeUntil, catchError, tap } from 'rxjs/operators';
import { Subject, of, forkJoin } from 'rxjs';

@Component({
  selector: "app-save-question",
  templateUrl: "./save-question.component.html",
  styleUrls: ["./save-question.component.scss"],
  providers: [
    OptionTypesService,
    QuestionsService,
    FeedbackService,
    QuestionGroupsService,
    PartnerService
  ],
})
export class SaveQuestionComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild("f", { static: true }) form: NgForm;
  optionTypes: IOptionType[] = [];
  title: string;
  question: IQuestion;
  optionTypeId: number;
  @Input() questionId: number;
  @Input() questionGroupId: number;
  @Input() questionGroupQuestionIndex: number;
  @Output() complete: EventEmitter<void> = new EventEmitter();
  selectedOptionValue: IOptionValue | null;
  isEditMode: boolean;
  isOptionValueSelected: boolean = false;
  isLoading: boolean = false;
  @Input() questionGroups: IQuestionGroup[] = [];
  isAddingOptionValueQuestionGroup: boolean = false;
  isAddingAssessmentMessageToQuestionGroup: boolean = false;
  isEditingAssessmentMessage: boolean = false;
  selectedAssessmentMessage: IAssessmentMessage | null;
  isOptionValueQuestionGroupSelected: boolean = false;
  isOptionValueAssessmentMessageSelected: boolean = false;
  partnerTypes: IPartnerType[];
  questionTypes: IQuestionType[];

  constructor(
    private readonly optionTypesService: OptionTypesService,
    private readonly questionsService: QuestionsService,
    private readonly questionGroupsService: QuestionGroupsService,
    private readonly feedbackService: FeedbackService,
    private readonly partnerService: PartnerService
  ) {}

  ngOnInit() {
    this.populateOptionTypes();
    this.populatePartnerTypes();
    this.populateQuestionTypes();
    if (this.questionId && this.questionGroupId) {
      this.isEditMode = true;
      this.title = "Edit question";
      console.log("at nginit edit mode");

      this.questionsService.getQuestionById(this.questionId).pipe(
        takeUntil(this.destroy$)
      ).subscribe({
        next: (response) => {
          if (response) {
            this.question = response;
          } else {
            this.feedbackService.show("This question does not exist");
            this.complete.emit();
          }
        },
        error: (error) => {
          this.feedbackService.error(error);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    } else {
      this.title = "Create question";
      var option = new Option();
      var optionsArray: IOption[] = [];
      optionsArray.push(option);
      this.question = new Question("", "", "", optionsArray);
      this.isLoading = false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  save() {
    console.log("Save - Save-Question");
    this.isLoading = true;
    this.question.description = this.question.name;
    if (this.isEditMode) {
      // Update question
      console.log("EM - Save-Question");
      this.question.options.forEach((o) => {
        this.sortOptionValueIndices(o);
      });
      this.question.description = this.question.name;
      this.questionsService.update(this.question).pipe(
        tap(() => {
          this.feedbackService.success("Question saved");
          this.complete.emit();
        }),
        catchError((error) => {
          this.feedbackService.error("An error occurred while saving the question");
          return of(null);
        })
      ).subscribe();
    } else {
      // Create question
      this.question.prepare();
      const questionGroupQuestion = new QuestionGroupQuestion();
      questionGroupQuestion.questionGroupId = this.questionGroupId;
      questionGroupQuestion.question = this.question;
      questionGroupQuestion.index = this.questionGroupQuestionIndex;
      questionGroupQuestion.prepare();
      this.questionGroupsService
        .createQuestionGroupQuestion(questionGroupQuestion)
        .pipe(
          tap(() => {
            this.feedbackService.success("Question created");
            this.complete.emit();
          }),
          catchError((error) => {
            this.feedbackService.error(
              `There was a problem saving the Email template.`
            );
            console.error(error);
            return of(null);
          })
        )
        .subscribe();
    }
  }

  cancel() {
    this.complete.emit();
  }

  isSubmitDisabled(): boolean {
    //console.log("at submit disabled chk");
    //const formInvalid = !this.form.valid;
    //let optionsInvalid = false;

    //if (!formInvalid) {
    //  this.question.options.forEach((o) => {
    //    if (!o.optionTypeId || o.optionTypeId === 0) {
    //      optionsInvalid = true;
    //    }
    //  });
    //}

    //return formInvalid || optionsInvalid;
    return false;
  }

  dropOptionValue(
    event: CdkDragDrop<string>,
    optionValueArray: IOptionValue[]
  ) {
    moveItemInArray(optionValueArray, event.previousIndex, event.currentIndex);
  }

  dropOptionValueQuestionGroup(
    event: CdkDragDrop<string>,
    optionValueQuestionGroupArray: IOptionValueQuestionGroup[]
  ) {
    moveItemInArray(
      optionValueQuestionGroupArray,
      event.previousIndex,
      event.currentIndex
    );
  }

  deleteOptionValue(
    optionValueArray: IOptionValue[],
    optionValue: IOptionValue
  ) {
    const index = optionValueArray.indexOf(optionValue, 0);
    if (index > -1) {
      optionValueArray.splice(index, 1);
    }

    this.isOptionValueSelected = false;
    this.selectedOptionValue = null;
  }

  optionTypeChanged(option: IOption) {
    option.optionValues = [];
    if (this.isYesNoControlType(option.optionTypeId)) {
      option.optionValues.push(new OptionValue(option.optionId, "No", 1, 0));
      option.optionValues.push(new OptionValue(option.optionId, "Yes", 2, 0));
      this.isOptionValueSelected = true;
      this.selectedOptionValue = option.optionValues[0];
    } else if (this.isText(option.optionTypeId)) {
      const ov = new OptionValue(option.optionId, "", 1, 0);
      option.optionValues.push(ov);
      this.isOptionValueSelected = false;
      this.selectedOptionValue = null;
    } else {
      this.isOptionValueSelected = false;
      this.selectedOptionValue = null;
    }
  }

  selectOptionValue(optionValue: IOptionValue) {
    console.log("select Option Value Called");
    this.selectedOptionValue = optionValue;
    this.isOptionValueSelected = true;
  }

  showOptionValueQuestionGroup(optionValue: IOptionValue) {
    this.selectedOptionValue = optionValue;
    this.isOptionValueQuestionGroupSelected = true;
    this.isOptionValueSelected = true;
    this.isOptionValueAssessmentMessageSelected = false;
  }

  hideOptionValueQuestionGroup() {
    this.isOptionValueQuestionGroupSelected = false;
    this.isAddingOptionValueQuestionGroup = false;
    this.isAddingOptionValueQuestionGroup = false;
  }

  showOptionValueAssessmentMessage(optionValue: IOptionValue) {
    this.selectedOptionValue = optionValue;
    this.isOptionValueAssessmentMessageSelected = true;
    this.isOptionValueQuestionGroupSelected = false;
  }

  hideOptionValueAssessmentMessage() {
    this.isOptionValueAssessmentMessageSelected = false;
  }

  createNewOptionValue(optionValueArray: IOptionValue[], optionId: number) {
    var newOptionValue = new OptionValue(optionId);
    optionValueArray.push(newOptionValue);

    this.isOptionValueSelected = true;
    this.selectedOptionValue = newOptionValue;
  }

  optionValueAdded(option: IOption) {
    console.log(option);
    this.isOptionValueSelected = false;
  }

  isText(optionTypeId: number) {
    return ControlHelpers.isText(optionTypeId);
  }

  isYesNoControlType(optionTypeId: number) {
    return ControlHelpers.isYesNoControlType(optionTypeId);
  }

  isListTypeControl(optionTypeId: number) {
    return ControlHelpers.isListTypeControl(optionTypeId);
  }

  isDisplayHelpTextField(optionTypeId: number) {
    const controlType = ControlHelpers.getControlType(optionTypeId);
    return controlType === CheckBoxList || controlType === RadioButtonList;
  }

  createNewOptionValueQuestionGroup() {
    this.isAddingOptionValueQuestionGroup = true;
  }

  optionValueQuestionGroupSelected(questionGroupId: number) {
    const questionGroup = this.questionGroups.find(
      (qg) => qg.questionGroupId === questionGroupId
    );
    if (questionGroup && this.selectedOptionValue != null) {
      this.selectedOptionValue.optionValueQuestionGroups.push(
        new OptionValueQuestionGroup(
          this.selectedOptionValue!.optionValueId,
          questionGroup.questionGroupId,
          questionGroup
        )
      );
    }
    this.isAddingOptionValueQuestionGroup = false;
  }

  deleteOptionValueQuestionGroup(questionGroupId: number) {
    if (this.selectedOptionValue != null) {
      this.isAddingOptionValueQuestionGroup = false;
      _.remove(
        this.selectedOptionValue.optionValueQuestionGroups,
        (qg) => qg.questionGroupId === questionGroupId
      );
    }
  }

  createNewAssessmentMessage() {
    this.isAddingAssessmentMessageToQuestionGroup = true;
    this.isEditingAssessmentMessage = false;
  }

  editAssessmentMessage(assessmentMessageId: number) {
    if (this.selectedOptionValue) {
      var assMsg = this.selectedOptionValue.assessmentMessages.find(
        (a) => a.assessmentMessageId === assessmentMessageId
      );
      if (assMsg) {
        this.selectedAssessmentMessage = assMsg;
        this.isEditingAssessmentMessage = true;
        this.isAddingAssessmentMessageToQuestionGroup = false;
      }
    }
   
  }

  deleteAssessmentMessage(assessmentMessageId: number) {
    if (this.selectedOptionValue) {
      _.remove(
        this.selectedOptionValue.assessmentMessages,
        (a) => a.assessmentMessageId === assessmentMessageId
      );
    }
  }

  assessmentMessageAdded(assessmentMessage: IAssessmentMessage) {
    if (this.selectedOptionValue) {
      if (this.isAddingAssessmentMessageToQuestionGroup) {
        this.selectedOptionValue.assessmentMessages.push(assessmentMessage);
      }
      this.isAddingAssessmentMessageToQuestionGroup = false;
      this.isEditingAssessmentMessage = false;
      this.selectedAssessmentMessage = null;
    }
  }

  private populateOptionTypes() {
    this.isLoading = true;
    this.optionTypesService.getAllOptionTypes().subscribe(
      (response) => {
        if (response) {
          this.optionTypes = _.sortBy(response, ["description"]);
        }
      },
      () => {
        this.feedbackService.error(
          "An error occured while fetching option types"
        );
        this.complete.emit();
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  private populateQuestionTypes() {
    this.questionsService.getQuestionTypes().subscribe(response => {
      this.questionTypes = response;
    });
  }

  private populatePartnerTypes() {
    this.isLoading = true;
    this.partnerService.getAllPartnerTypes().subscribe(
      (response) => {
        if (response) {
          this.partnerTypes = response;
        }
      },
      () => {
        this.feedbackService.error(
          "An error occured while fetching partner types"
        );
        this.complete.emit();
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  private sortOptionValueIndices(option: IOption) {
    for (let i = 0; i < option.optionValues.length; i++) {
      const optionValue = option.optionValues[i];
      optionValue.index = i + 1;
      optionValue.optionId = option.optionId;
      for (let j = 0; j < optionValue.optionValueQuestionGroups.length; j++) {
        const ovqg = optionValue.optionValueQuestionGroups[j];
        ovqg.index = j + 1;
        ovqg.questionGroup = null;
      }

      for (let k = 0; k < optionValue.assessmentMessages.length; k++) {
        const am = optionValue.assessmentMessages[k];
        am.index = k + 1;
      }
    }
  }
}
